<template>
  <a-modal :visible="visible" @ok="process" @cancel="cancel" width="500px" :confirmLoading="loading.confirm"
    :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;LKPD Recapitulation Process</span>

    <a-form-model
      ref="formDialog"
      :model="formDialog.form"
      :rules="formDialog.rules"
    >
      <a-form-model-item label="Period" prop="period">
        <a-month-picker
          v-model="formDialog.form.period"
          placeholder="Select Period" format="MMMM-YYYY"
        />
      </a-form-model-item>
      <a-form-model-item label="Currency" hidden>
        <a-radio-group
          buttonStyle="solid"
          v-model="formDialog.form.currency"
          @change="changeCurrency"
        >
          <a-radio-button value="IDR">IDR</a-radio-button>
          <a-radio-button value="USD">USD</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="formDialog.form.currency=='USD'" :label="'Exchange Rate to IDR'" prop="exchange_rate">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right" style="padding-right: 15px;"
          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          @keydown="onlyNumber"
          @change="changeRate"
          v-model="formDialog.form.exchange_rate"
        ></a-input-number>
      </a-form-model-item>
      <a-form-model-item v-if="formDialog.form.currency=='USD'" :label="'Total Recapitulation ('+formDialog.form.currency+')'" prop="total_rekap_usd">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="(value) => value.replace(formDialog.form.currency, '')"
          @keydown="onlyNumber"
          disabled
          v-model="formDialog.form.total_rekap_usd"
        ></a-input-number>
      </a-form-model-item>
      <a-form-model-item :label="'Total Recapitulation (IDR)'" prop="total_rekap">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="(value) => `${initCUrIDR} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="(value) => value.replace('IDR', '')"
          @keydown="onlyNumber"
          disabled
          v-model="formDialog.form.total_rekap"
        ></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="Description" prop="description">
        <a-textarea placeholder="Write the note here ... " :rows="4" v-model="formDialog.form.description" :disabled="loading.confirm"/>
      </a-form-model-item>
      <a-form-model-item label="Document Support" prop="document_support">
        <a-upload :fileList="formDialog.fileList" v-model="formDialog.form.document_support" 
          :remove="handleRemove" 
          :beforeUpload="beforeUpload"
          :disabled="loading.confirm"
          >
          <a-button>
            <a-icon type="upload" />Select File
          </a-button>
        </a-upload>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer" class="flex">
      <a-button type="default" class="m-width-full margin-bottom-small" @click="processPreview" :loading="loading.preview">Preview</a-button>
      <a-button type="primary" class="m-width-full" @click="process" :loading="loading.confirm">Process Recapitulation</a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";
import axios from "axios";
import moment from "moment";

export default {
  name: "DialogProcess",
  mixins: [GlobalMethod, CurrencyFormat],
  props: ["visible","selectedData"],
  data(){
    let doc_validation = (rule, value, callback) => {
      if (this.formDialog.fileList == null || this.formDialog.fileList.length==0) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };

    return {
      loading: {
        confirm: false,
        preview: false
      },
      formDialog:{
        form: {
          exchange_rate: "",
          currency: "IDR",
          period: null,
          total_rekap: null,
          total_rekap_usd: null,
          description: null,
          document_support: null
        },
        rules: {
          exchange_rate: {
            required: true,
            message: "Exchange Rate is required!",
            trigger: "change",
          },
          period: {
            required: true,
            message: "period is required!",
            trigger: "change",
          },
          total_rekap: {
            required: true,
            message: "Total Recapitulation is required!",
            trigger: "change",
          },
          total_rekap_usd: {
            required: true,
            message: "Total Recapitulation is required!",
            trigger: "change",
          },
          description: {
            required: true,
            message: "Description is required!",
            trigger: "change",
          },
          document_support: {
            required: false,
            // validator: doc_validation,
            message: "Document Support is required!",
            trigger: "change",
          },
        },
        fileList:[]
      }
    }
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
    initCUr() {
      return this.symbolCurrencyES6(this.formDialog.form.currency, 0);
    },
    initCUrIDR() {
      return this.symbolCurrencyES6('IDR', 0);
    },
  },
  mounted(){
    this.sumTotalSelected()
  },
  methods:{
    moment,
    process(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        let formData = new FormData();
        formData.append("periode", moment(this.formDialog.form.period).format('YYYY-MM'));
        formData.append("currency", this.formDialog.form.currency);
        formData.append("total", this.formDialog.form.currency=="USD" ? this.formDialog.form.total_rekap_usd : this.formDialog.form.total_rekap);
        formData.append("total_new", this.formDialog.form.total_rekap);
        formData.append("kurs", this.formDialog.form.exchange_rate);
        formData.append("description", this.formDialog.form.description);
        formData.append("total", this.formDialog.form.total_rekap);
        if(this.formDialog.fileList && this.formDialog.fileList.length>0)
          formData.append(`file_support`, this.formDialog.fileList[0]);
        if(this.selectedData.length>0){
          this.selectedData.forEach((element,index) => {
            formData.append(`selected_item[${index}]`, element.new_id);
          });
        }else{
          this.displayMessageValue("error-other", 'No data Selected!');
          return
        }

        this.loading.confirm = true
        this.asyncAxiosPost("rekap_lkpd",
          "formdata", this.getAuth, formData)
        .then(() => {
          Event.$emit("closeDiagProc");
          Event.$emit("fetchTab");
          this.displayMessage("success-save");
          this.loading.confirm = false
        })
        .catch(() => {
          this.loading.confirm = false
        });
      })
    },
    processPreview(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        let formData = new FormData();
        formData.append("periode", moment(this.formDialog.form.period).format('YYYY-MM'));
        formData.append("kurs", this.formDialog.form.exchange_rate);
        formData.append("description", this.formDialog.form.description);
        this.selectedData.forEach((element,index) => {
          formData.append(`selected_item[${index}]`, element.new_id);
        });

        this.loading.preview = true
        axios({
          method: "post",
          url: this.$serviceUrl + "rekap_lkpd/preview",
          data: formData,
          responseType: "blob",
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.previewLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.loading.preview = false
        })
        .catch(() => {
        });
      })
    },
    sumTotalSelected(){
      this.formDialog.form.total_rekap = _.sumBy(this.selectedData, function (val) {
        return val.total_pd ? Number(val.total_pd) : 0
      });
    },
    sumTotalSelectedUSD(){
      this.formDialog.form.total_rekap_usd = _.sumBy(this.selectedData, function (val) {
        return val.total_ln ? Number(val.total_ln) : 0
      });
      this.formDialog.form.total_rekap = 0
    },
    cancel(){
      Event.$emit("closeDiagProc");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.formDialog.fileList = [file];
        return false;
      }
    },
    handleRemove() {
      this.formDialog.fileList = [];
    },
    changeCurrency(val){
      this.formDialog.form.exchange_rate = 0
      if(val.target.value=="USD"){
        this.sumTotalSelectedUSD()
      }else{
        this.sumTotalSelected()
      }
    },
    changeRate(val){
      if(val){
        this.formDialog.form.total_rekap = this.formDialog.form.total_rekap_usd*val
      }else{
        this.formDialog.form.total_rekap = 0
      }
    }
  }
}
</script>
<style lang="less">
.m-text-align-right{
  input{
    text-align: right;
  }
}
</style>